module.exports = __webpack_public_path__ + "static/media/discuss.7b56f110.png";